import ComponentLayout from "../../../../src/layouts/component-layout";
import { HeadingTags, AccordionToggleColors } from '@primer/react-brand';
import { Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  HeadingTags,
  AccordionToggleColors,
  Label,
  PropTableValues,
  React
};